import { render, staticRenderFns } from "./ConfirmYourInfo.vue?vue&type=template&id=5ad0f2a4&scoped=true&"
import script from "./ConfirmYourInfo.vue?vue&type=script&lang=ts&"
export * from "./ConfirmYourInfo.vue?vue&type=script&lang=ts&"
import style0 from "./ConfirmYourInfo.vue?vue&type=style&index=0&id=5ad0f2a4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ad0f2a4",
  null
  
)

export default component.exports